import React from "react";
import HeroLayout from "../components/HeroLayout";
const images = require.context("../assets/images", false);

function Authentic_Indian_Experiences() {
  return (
    <>
    <HeroLayout>
    <div
        className="banner-bg"
        style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./authentic.webp")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>AUTHENTIC INDIAN EXPERIENCES</h1>
            </div>
        </div>
        </div>
    </HeroLayout>
    <div className="indian-experience mt-80">
  <div className="container">
    <div className="heading full-width center">
      <h2>Authentic Indian Experiences</h2>
      <h3>“One who visits India, never forgets it.”</h3>
      <p style={{ textAlign: "justify" }}>
        Though there are many common travel routes in India like Golden Triangle
        Tour but to justify the above quote you need to experience the India in
        small towns and villages. These are the places where the various
        traditions &amp; rituals are being preserved from centuries.
      </p>
      <p style={{ textAlign: "justify" }}>
        The Indian culture is so diverse that there is a significant variation
        in language, traditions, festivals, cuisines &amp; art for every 40
        miles. We celebrate more than 200 festivals in a year. Anyhow, if you
        are lucky enough to plan a visit to these small places, you may get a
        chance to enjoy bullock cart ride, attend some wedding rituals, get a
        hair cut under mango tree, eat at road side Dhabas, celebrate festivals
        with local family, watch daily routine of a village woman, do some yoga
        &amp; get some natural wellness treatment or see how a village court
        works.
      </p>
      <p style={{ textAlign: "justify" }}>
        We at Virsa Travels, strive to provide our guests the true insights of
        Indian culture. Over the past years, we have included some handpicked
        authentic Indian experience for our guests. Please check below the
        handful of authentic Indian experiences and ask us to include them(any)
        in your upcoming tour.
      </p>
    </div>
    <div className="row">
    
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Cooking-Class-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">
              Cooking class with a local family
            </h4>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Henna-Tattoo-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">Get a heena tattoo</h4>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./festival-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">Celebrate festival with Indian family</h4>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Street-Food-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">
              Visit local market for street food
            </h4>
          </div>
        </div>
      </div>
      
      
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Market-Walking-Tour-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">Walking tour in local market</h4>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Indian-Wedding.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">Attend an Indian wedding</h4>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Cultural-Dance-Show-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">
              Cultural dance show
            </h4>
          </div>
        </div>
      </div>

      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Varanasi-Boat-Ride-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">Boat ride in Varanasi</h4>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Homestay-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">
             Homestay with a local family

            </h4>
          </div>
        </div>
      </div>

      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Camel-Ride-Pushkar-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">Camel ride in rural village</h4>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Ayurvedic-Body-Massage-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">
             Ayurvedic body massage
            </h4>
          </div>
        </div>
      </div>
            <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Village-Tour-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">Local village visit</h4>
          </div>
        </div>
      </div>
      <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Yoga-Class-India.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">
             Introduction to daily yoga </h4>
          </div>
        </div>
      </div>
            <div className="col-md-6 col-lg-3 col-xl-3">
        <div className="indian-experience-card">
          <img src={images("./Traditional-music-Rajasthan.jpg")} />
          <div className="experience-details">
            <h4 className="font-18">Local music live show in Rajasthan</h4>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>

    </>
  );
}

export default Authentic_Indian_Experiences;